import React from 'react'
import PropTypes from 'prop-types'

const InitailIcon = (props) => {
  const { color = '#183560', classes = 'w-20' } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.90476 16.4476V3.90476H19.1429V9.61905H21.0476V3.90476C21.0476 2.85714 20.1905 2 19.1429 2H3.90476C2.85714 2 2.00952 2.85714 2.00952 3.90476L2 21.0476L5.80952 17.2381H14.381V15.3333H5.01905L3.90476 16.4476Z"
        fill={color}
      />
      <path
        d="M21.5238 15.3334H19.4286L21.0476 11.5238H16.2857V17.2381H18.1905V22L21.5238 15.3334Z"
        fill={color}
      />
    </svg>
  )
}

InitailIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(InitailIcon)
